import { Suspense, useContext } from "react";
import { ComponentSpinner } from "@components/spinner";
import { Navigate } from "react-router-dom";
import { PanelDefaultRoute, SuperAdminDefaultRoute } from "./routes";
import { UserContext } from "@context/user";
import size from "lodash/size";
import themeConfig from "@configs/theme-config";
import { getItemFromStore } from "@src/utility/helpers/utils";

const PublicRoute = ({ children, route }) => {
    const { app:{ name } } = themeConfig;

    if (route) {
        const { userData } = useContext(UserContext);
        const title = name;
        const restrictedRoute = route.meta && route.meta.restricted;
        if (size(userData?.user) && restrictedRoute) {
            return <Navigate to={PanelDefaultRoute} />;
        }
        if (getItemFromStore("token-superadmin") && restrictedRoute) {
            return <Navigate to={SuperAdminDefaultRoute} />;
        }
        document.title = route.meta.title || title;
    }

    return <Suspense fallback={<ComponentSpinner className="mt-5 pt-5" />}>{children}</Suspense>;
    
};

export default PublicRoute;
